import React from 'react';
import style from 'acscp/components/common/callUsPopover.module.scss';
import { FormattedMessage } from 'react-intl';
import { PresentationComponentBase } from 'acscp/components/presentationComponentBase';
import { CrossIcon } from 'acscp/components/common/icons/crossIcon';
import { CallUsIcon } from 'acscp/components/common/icons/callUsIcon';
import { connect } from 'react-redux';
import { AppState } from 'acscp/store';

interface CallUsPopoverOwnProps {
    closeSelf: () => void;
}

interface CallUsPopoverStateProps {
    callUsNumber?: string;
}

export class CallUsPopoverPresentational extends PresentationComponentBase<CallUsPopoverOwnProps, CallUsPopoverStateProps, {}, {}> {
    render(): JSX.Element {
        return (
            <div className={style.Popover}>
                <div className={style.PopoverHeader}>
                    <span>
                        <span className={style.Icon}>
                            <CallUsIcon />
                        </span>
                        <FormattedMessage id={'components.callUsPopover.callUsHeader'} defaultMessage={'CALL US'} />
                    </span>
                    <CrossIcon
                        className={style.Cross}
                        onClick={this.props.closeSelf}
                        aria-label="Close modal window"
                    />
                </div>
                <div className={style.PopoverBody}>
                    <p className={style.Description}>Air Charter Service Ltd.</p>
                    <p className={style.Number}>{this.props.callUsNumber || (
                        <FormattedMessage id={'components.callUsPopover.fallbackNumber'} defaultMessage={'+44 (0)20 8339 8588'} />
                    )}</p>
                </div>
            </div>
        );
    }
}

function mapStateToProps(state: AppState): CallUsPopoverStateProps {
    return {
        callUsNumber: state.customerContact.acsContactTelephoneNumber
    };
}

export const CallUsPopover = connect(mapStateToProps)(CallUsPopoverPresentational);
